export const OrgStatusType = {
  WAITING_APPROVAL: 1,
  PENDING: 2,
  ESTABLISHED: 3,
  REJECTED: 4,
};
